// 登録完了モーダル
const ModalSaveSuccess = {
  namespaced: true,

  state: {
    modal: false,
    type: 'new', // new, edit, tmp
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getType: state => {
      return state.type
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setType(state, type) {
      state.type = type
    },
  },
  actions: {
    set({ commit }, item) {
      commit('setType', item.type)
      commit('setModal', true)
    },
    reset({ commit }) {
      commit('setModal', false)
      commit('setType', 'new')
    },
  },
}

export default ModalSaveSuccess
